export default __webpack_public_path__ + "static/media/fireFN4.f44db963.svg";